import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { GrocyContextDataApi } from '../../../../../core/api/grocy/context-data.api';
import { GrocyRegisteredPurchasesApi } from '../../../../../core/api/grocy/registered-purchases.api';
import { GrocyContextData } from '../../../../../core/entities/grocy/context-data/context-data.entity';
import { GrocyRegisteredPurchase } from '../../../../../core/entities/grocy/registered-purchases/registered-purchase.entity';
import { GrocySuccess } from '../../../../../core/entities/grocy/shared/success.entity';
import { GrocyStockLog } from '../../../../../core/entities/grocy/stock-logs/stock-log.entity';
import { GrocyDashboardService } from '../../../shared/services/dashboard.service';
import { GrocyDashboardShoppingItemForm } from '../../forms/dashboard-shopping-item.form';
import { GrocyDashboardShoppingSessionForm } from '../../forms/dashboard-shopping-session.form';
import { GrocyActionDialogComponent } from '../action-dialog/action-dialog.component';

@Component({
  selector: 'app-grocy-register-shopping-dialog',
  templateUrl: './register-shopping-dialog.component.html',
  styleUrl: './register-shopping-dialog.component.scss',
})
export class GrocyRegisterShoppingDialogComponent extends GrocyActionDialogComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;

  columns = ['product', 'breakdown', 'price', 'undo'];
  contextData?: GrocyContextData;
  dataSource = new MatTableDataSource<GrocyRegisteredPurchase>([]);
  finishShoppingClicked = false;
  showErrors = false;
  toggleErrors = new EventEmitter<void>();

  constructor(
    private contextDataApi: GrocyContextDataApi,
    private registeredPurchasesApi: GrocyRegisteredPurchasesApi,
    service: GrocyDashboardService
  ) {
    super(service);
  }

  ngOnInit(): void {
    this.contextDataApi.getContextData().subscribe((contextData: GrocyContextData) => {
      this.contextData = contextData;
      this.dataSource.data = contextData.registeredPurchases;
    });
  }

  get isSubmitting(): boolean {
    return this.service.state.isSubmitting;
  }

  get itemForm(): GrocyDashboardShoppingItemForm {
    return this.forms.shopping.item;
  }

  get priceProgress(): number {
    if (this.dataSource) {
      return this.dataSource.data.reduce((total, purchase) => total + purchase.actualPrice + purchase.totalPant, 0);
    }

    return 0;
  }

  get progress(): number {
    return (this.priceProgress * 100) / this.sessionForm.controls.totalPrice.value!;
  }

  get recentStockLogs(): GrocyStockLog[] {
    return this.service.selectedProduct()?.recentStockLogs || [];
  }

  get sessionForm(): GrocyDashboardShoppingSessionForm {
    return this.forms.shopping.session;
  }

  finishShopping(): void {
    this.registeredPurchasesApi.clearCache().subscribe(() => {
      this.sessionForm.formGroup.reset({ date: new Date(), totalPrice: 0.0 });
      this.productForm.formGroup.reset();
      this.itemForm?.formGroup.reset();
    });
  }

  finishShoppingConfirmation(): void {
    this.finishShoppingClicked = true;
  }

  nextStep(): void {
    this.stepper.next();
  }

  submit(): void {
    this.service.submitRegisteredPurchase().subscribe((registeredPurchases: GrocyRegisteredPurchase[]) => {
      this.dataSource.data = registeredPurchases;
    });
  }

  undoTransaction(transactionId: string): void {
    this.service.undoTransaction(transactionId).subscribe((success: GrocySuccess) => {
      if (success.succeeded) {
        this.dataSource.data = this.dataSource.data.filter(purchase => purchase.transactionId !== transactionId);
      }
    });
  }
}
